// extracted by mini-css-extract-plugin
export default {"product":"styles_product__8LS2j","product_title":"styles_product_title__mVKOY"};